import React, { useEffect } from "react";
import { connect } from "react-redux";

import { Loading } from "Components";

function checkLoading(state, list) {
  return Object.entries(state).every(([k, v]) => {
    return Object.keys(v).every(uid => {
      return list[k] && Object.keys(list[k]).includes(uid);
    });
  });
}

const CheckLoading = connect(state => ({
  state: state.state,
  list: state.list
}))(props => {
  const { dispatch, state, list } = props;
  useEffect(() => {
    if (state && Object.keys(state).length &&
      list && Object.keys(list).length
    ) {
      if (checkLoading(state, list)) {
        dispatch({ type: "DATA_LOADED" });
      }
    }
  }, [dispatch, state, list]);
  return <Loading absolute />;
});

function WaitData(props) {
  if (props.dataLoaded) return props.children;
  else return <CheckLoading />;
}

export default connect(state => ({
  dataLoaded: state.simtopy.dataLoaded
}))(WaitData);
